import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Line, Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import { useNavigate } from 'react-router-dom';
import './style.css';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

Chart.register(...registerables);

const Dashboard = () => {
    const [auth, setAuth] = useState('');
    const [expenseData, setExpenseData] = useState([]);
    const [employeeCount, setEmployeeCount] = useState(0);
    const [purchaseData, setPurchaseData] = useState([]);
    const [clientPercentages, setClientPercentages] = useState([]);

    useEffect(() => {
        // Fetch expense data
        axios.get('https://react-apis.dotlocalhost.com/getExpenseReports.php')
            .then(response => setExpenseData(response.data));

        // Fetch employee count
        axios.get('https://react-apis.dotlocalhost.com/getEmployeeCount.php')
            .then(response => setEmployeeCount(response.data.employeeCount));

        // Fetch purchase quantity data
        axios.get('https://react-apis.dotlocalhost.com/getPurchaseQuantity.php')
            .then(response => setPurchaseData(response.data));

        // Fetch client purchase and sales percentages
        axios.get('https://react-apis.dotlocalhost.com/getClientPurchaseSalesPercentage.php')
            .then(response => setClientPercentages(response.data))
            .catch(error => console.error("Error fetching client data:", error));
    }, []);

    const chartData = {
        labels: expenseData.map(d => d.day),
        datasets: [
            {
                label: 'Transfer',
                data: expenseData.map(d => d.expense),
                backgroundColor: '#447988',
            },
        ],
    };

    let navigate = useNavigate();

    useEffect(() => {
        var auth = localStorage.getItem('email');
        setAuth(auth);
    }, [])

    if (auth === null) {
        navigate('/');
    }

    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />
                <div className='ineerBody'>
                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Dashboard</h3>
                        </div>
                    </div>

                    <div className="dashboard">
                        <div className="card">
                            <h3>Number of Clients</h3>
                            <p>{employeeCount}</p>
                        </div>

                        <div className="card chart">
                            <h3>Cash Transfer Reports Per Day</h3>
                            <Bar data={chartData} />
                        </div>

                        <div className="card chart">
                            <h3>Purchase Quantity Per Day</h3>
                            <Bar data={{
                                labels: purchaseData.map(d => d.day),
                                datasets: [
                                    {
                                        label: 'Quantity',
                                        data: purchaseData.map(d => d.total_quantity),
                                        backgroundColor: '#82B4B1',
                                    },
                                ],
                            }} />
                        </div>

                    </div>

                    <div className="dashboard">

                        <div className="card">
                            <h3>Client Purchase and Sales Percentage</h3>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Client Name</th>
                                        <th>Purchase (%)</th>
                                        <th>Sales (%)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {clientPercentages.map((client, index) => (
                                        <tr key={index}>
                                            <td>{client.clientName}</td>
                                            <td>{client.purchase_percentage.toFixed(2)}%</td>
                                            <td>{client.sales_percentage.toFixed(2)}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
